import React from 'react';
import { Button, HeadingText, Icon, TitleText } from '@paypalcorp/pp-react';
import styles from './CustomizeCardsSection.module.less';

// type for the feature prop
export type Feature = {
  title: string;
  url: string;
  description: string;
};

// Define the props for the CardComponent
type CardComponentProps = {
  feature: Feature;
};

const CardComponent = ({ feature }: CardComponentProps) => {
  return (
    <div className={styles.features_wrapper}>
      <HeadingText className={styles.feature_title_wrapper} size="sm" type="regular">
        <Button
          variant="tertiary"
          as="a"
          href={feature.url}
          role="button"
          className={styles.feature_title}
        >
          {feature.title} <Icon name="arrow-right" size="md" color="sysColorLinkMain" />
        </Button>
      </HeadingText>
      <TitleText>{feature.description}</TitleText>
    </div>
  );
};

export default CardComponent;
